// Cookie Banner KOVA — Conforme CNIL / RGPD
// Le HTML du banner est inline dans chaque page (visible par les crawlers sans JS)
// Ce script gère uniquement la logique show/hide et le stockage du consentement

(function() {
  var COOKIE_NAME = 'kova_cookie_consent';
  var COOKIE_DAYS = 395; // 13 mois (recommandation CNIL)

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires +
      '; path=/' +
      '; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
    try { localStorage.setItem(name, value); } catch(e) {}
  }

  function hideBanner() {
    var el = document.getElementById('kova-gdpr-banner');
    if (!el) return;
    el.style.transition = 'transform 0.35s ease, opacity 0.35s ease';
    el.style.transform = 'translateY(100%)';
    el.style.opacity = '0';
    setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 380);
  }

  function accept() {
    setCookie(COOKIE_NAME, 'accepted', COOKIE_DAYS);
    hideBanner();
    if (window.dataLayer) window.dataLayer.push({ event: 'cookie_consent_accepted' });
  }

  function refuse() {
    setCookie(COOKIE_NAME, 'refused', COOKIE_DAYS);
    hideBanner();
    if (window.dataLayer) window.dataLayer.push({ event: 'cookie_consent_refused' });
  }

  function initBanner() {
    var el = document.getElementById('kova-gdpr-banner');
    if (!el) return;

    // Si consentement déjà donné → masquer immédiatement sans animation
    if (getCookie(COOKIE_NAME)) {
      el.style.display = 'none';
      return;
    }

    // Sinon : afficher et brancher les boutons
    var btnAccept = document.getElementById('kova-cookie-accept');
    var btnRefuse = document.getElementById('kova-cookie-refuse');
    if (btnAccept) btnAccept.addEventListener('click', accept);
    if (btnRefuse) btnRefuse.addEventListener('click', refuse);
  }

  // Lancer dès que le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBanner);
  } else {
    initBanner();
  }
})();
